// extracted by mini-css-extract-plugin
export default {"circleProgress":"ProfileProgress_circleProgress__E79eh"};